import { Component, OnInit } from "@angular/core";
import { clientService } from "../shared/client.service";
import { Router } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { ClientViewModel } from "@app/shared/models/clients/ClientViewModel.model";
import { FeatureFlagsService } from "@app/agilx/shared/feature-flags.service";

@Component({
  selector: "app-clientlist",
  templateUrl: "./clientlist.component.html",
  styleUrls: ["./clientlist.component.css"],
})
export class ClientlistComponent implements OnInit {
  errorMsg: any;
  clientList: any = [];
  colsClients: any = [];
  showDeleted = false;
  filteredClients: any = [];

  filters = {
    customerNo: "",
    companyName: "",
    phone: "",
    email: "",
    city: "",
  }

  newButtonAction: any = this.onClickNew;
  newButtonOptions: any = [
    {
        label: 'New Client',
        command: () => {
            this.onClickNew();
        }
    }
  ];

  constructor(
    private _clientList: clientService,
    private router: Router,
    private _AuthService: authenticationService,
    private featureFlagsService: FeatureFlagsService
  ) {}

  ngOnInit() {
    this.colsClients = [
      { field: "customerNo", header: "Client Id" },
      { field: "companyName", header: "Company Name" },
      { field: "phone", header: "Contact #" },
      { field: "email", header: "Email" },
      { field: "city", header: "City" },
    ];

    this._clientList.getClientList(false, true).subscribe(
      (resClientListData) => {
        this.clientList = resClientListData;
      },
      (resClientListError) => {
        this.errorMsg = resClientListError;
      }
    );
  }

  viewDetail = (client: ClientViewModel) => {
    if (this.featureFlagsService.isEnabled('useNewClientPages')) {
      this.router.navigate(["/client-detail/", client.id]);
    } else {
      this.router.navigate(["/clientinfo/", client.id]);
    }
  }

  onClickNew() {
    this.router.navigate(["/newclient"]);
  }

  loadData(){
    return this._clientList.getClientList(false, true);
  }

  excelGeneration(selectedColumns: any[], selectedTrips: any[], filters: any, selectAll: boolean) {
    const colNames = selectedColumns.map((col) => col.header);
    const colFields = selectedColumns.map((col) => col.field);


    const observable = this._clientList.getClientList(false, true);
    observable.subscribe((res: any) => {
      const values = res.filter((client: any) => {
        return (
          (selectAll || selectedTrips.includes(client.id)) &&
          (!this.filters.customerNo || client.customerNo?.toLowerCase().includes(this.filters.customerNo.toLowerCase())) &&
          (!this.filters.companyName || client.companyName?.toLowerCase().includes(this.filters.companyName.toLowerCase())) &&
          (!this.filters.phone || client.phone?.toLowerCase().includes(this.filters.phone.toLowerCase())) &&
          (!this.filters.email || client.email?.toLowerCase().includes(this.filters.email.toLowerCase())) &&
          (!this.filters.city || client.city?.toLowerCase().includes(this.filters.city.toLowerCase()))
        );
      });

      //need this function because typeof returns 'boolean' for primitive booleans and 'object' for Boolean objects
      function isBoolean(val) {
        return val === false || val === true;
      }

      let plainRecords = values.map((trip) => {
        let tripRecord = [];
        for (const field of colFields) {
          const datatype = typeof trip[field];
          if (datatype === "string") trip[field] = trip[field].replace(/\r?\n|\r/g, "").toUpperCase();
          if (trip[field] && trip[field].toString().includes(",")) {
            tripRecord.push(`"${trip[field]}"`);
          } else if (isBoolean(trip[field])) {
            //for some reason data is coming in mixed as primitive booleans and Boolean objects.
            //the conditional after this prints empty strings for undefineds but also puts empty string instead of false
            tripRecord.push(trip[field] ? "TRUE" : "FALSE");
          } else {
            tripRecord.push(trip[field] || "");
          }
        }
        return tripRecord;
      });
      plainRecords.unshift(colNames);
      let CsvString = "";
      for (const rowItem of plainRecords) {
        CsvString += rowItem.join(",") + "\r\n";
      }
      CsvString = "data:application/csv," + encodeURIComponent(CsvString);
      let x = document.createElement("A");
      x.setAttribute("href", CsvString);
      x.setAttribute("download", "client_list_" + new Date().toLocaleDateString() + ".csv");
      document.body.appendChild(x);
      x.click();
    });
  }

}